import React, { useMemo } from "react";
import {
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import Cookies from "js-cookie";
import ROUTES, { DOCTOR_ROUTES, ADMIN_ROUTES, ASSISTANT_ROUTES } from "./routePaths";
import { MESSAGING_ROUTES } from "../../messagerie/routePaths";
import { DOCTOR_FINDER_ROUTES } from "../../DoctorFinder/routePaths";
import LandingPage from "../../Landing/pages/LandingPage/LandingPage";
import MedicalCaseDiscussions from "../../Medicalcase/pages/Medicalcasediscussions/Medicalcasediscussions";
import MedicalCaseDetail from "../../Medicalcase/pages/Medicalcasedetail/Medicalcasedetail";
import MedicalCaseLive from "../../Medicalcase/pages/Medicalcaselive/Medicalcaselive";
import CreateCase from "../../Medicalcase/pages/CreateCase/CreateCase";

import AssistantBubble from "../../assistanAi/components/AssistantBubble/AssistantBubble";
import SignupPatient from "../../authPatient/pages/SignupPatient/SignupPatient";
import LoginPatient from "../../authPatient/pages/LoginPatient/LoginPatient";
import VerifyCode from "../../authPatient/pages/VerifyCode/VerifyCode";
import ForgotPassword from "../../authPatient/pages/ForgotPassword/ForgotPassword";
import PatientMedicalRecord from "../../medicalRecord/pages/MedicalRecord/MedicalRecord";
import Messaging from "../../messagerie/pages/MessagingPatient";
import Appointments from "../../appointments/pages/Appointments/Appointments";
import DoctorDetails from "../../appointments/pages/DoctorDetails/DoctorDetails";
import Pharmacy from "../../places/pages/Pharmacy/PharmacyPatient";
import Lab from "../../places/pages/Lab/Lab";
import Clinique from "../../places/pages/Clinique/Clinique";
import Kine from "../../places/pages/Kine/Kine";
import Inf from "../../places/pages/Inf/Inf";
import PatientMedicines from "../../medications/pages/Medicines/Medicines";
import Profile from "../../Profile/pages/Profile/Profile";
import SideBar from "../../navigation/SideBar/SideBar";
import Feed from "../../feed/pages/FeedPatient/Feed";
import OverViewsPage from "../../Profile/pages/Overviews/Overviews";
import DoctorFinder from "../../DoctorFinder/pages/DoctorFinder/DoctorFinder";
import MapsLayout from "./MapsLayout";
import useAuthSession from "../../authPatient/hooks/useAuthSession";
import PublicRouteAuth from "../PublicRouteAuth";
import ProtectedRoute from "./ProtectedRoute";
import RecordType from "../../medicalRecord/pages/RecordType/RecordType";
import ProfileEdit from "../../Profile/pages/ProfileEdit/ProfileEdit";
import GeneralForm from "../../Profile/components/ProfileEditPage/GeneralForm/GeneralForm";
import HistoryForm from "../../Profile/components/ProfileEditPage/HistoryForm/HistoryForm";
import InsuranceForm from "../../Profile/components/ProfileEditPage/InsuranceForm/InsuranceForm";
import Cycle from "../../cycle/pages/Cycle/Cycle";
import Settings from "../../Settings/pages/Settings";
import Pets from "../../petsPage/Pets";
import MedicalQuestionsPage from "../../feed/pages/MedicalQuestionsPatient/MedicalQuestionsPage";
import MedicalAssistant from "../../assistanAi/pages/MedicalAssistant/MedicalAssistant";
import Medications from "../../medications/pages/Medications/Medications";
import RegisterForm1 from "../../authDoctor/pages/RegisterForm1/RegisterForm1";
import RegisterForm2 from "../../authDoctor/pages/RegisterForm2/RegisterForm2";
import RegisterForm3 from "../../authDoctor/pages/RegisterForm3/RegisterForm3";
import RegisterForm4 from "../../authDoctor/pages/RegisterForm4/RegisterForm4";
import LoginDoctor from "../../authDoctor/pages/LoginDoctor/LoginDoctor";
import VerifCode from "../../authDoctor/pages/VerifCode/VerifCode";
import ForgetPassword from "../../authDoctor/pages/ForgetPassword/ForgetPassword";
import EmailCode from "../../authDoctor/pages/EmailCode/EmailCode";
import SetNewPasswordDoctor from "../../authDoctor/pages/SetNewPassword/SetNewPassword";
import MessagingDoctor from "../../messagerie/pages/MessagingDoctor";
import FeedDoctor from "../../feed/pages/FeedDoctor/FeedDoctor";
import AppointmentsDoctor from "../../appointments/pages/AppointmentsDoctor/AppointmentsDoctor";
import Patients from "../../consultation/pages/Patients/Patients";
import PatientRecord from "../../consultation/pages/PatientRecord/PatientRecord";
import Perscription from "../../prescriptions/pages/Perscription/Perscription";
import ProfilDoctor from "../../ProfileDoctor/pages/ProfilDoctor/ProfilDoctor";
import AvailibilityPage from "../../availabilityDoctor/pages/availabilityPage/availabilityPage";
import SettingsDoctor from "../../Settings/pages/SettingsDoctor";
import Pharma from "../../places/pages/Pharmacy/PharmacyDoctor";
import Clinic from "../../places/pages//Clinique/Clinic";
import Laboratory from "../../places/pages/Lab/Laboratory";
import Nurses from "../../places/pages/Nurses/Nurses";
import MedicalQuestionsDoctor from "../../feed/pages/MedicalQuestionsDoctor/MedicalQuestionsDoctor";
import File from "../../consultation/pages/File/File";
import DoctorPatientProfile from "../../ProfileDoctor/pages/DoctorProfile/DoctorProfile";
import DoctorMedicalRecordPage from "../../medicalRecord/pages/MedicalRecord/DoctorMedicalRecordPage";
import DoctorMedicinesPage from "../../medications/pages/Medicines/DoctorMedicinesPage";
import DrProfile from "../../ProfileDoctor/pages/DoctorProfile/DrProfile";
import MedicationsDoctor from "../../medications/pages/Medications/MedicationsDoctor";
import OAuthCallback from "../../authPatient/pages/auth/OAuthCallback";
import DoctorRecordType from "../../medicalRecord/pages/Doctorrecordtype/Doctorrecordtype";
import Wastebasket from "../../medicalRecord/pages/Wastebasket/Wastebasket";
import SetNewPassword from "../../authPatient/pages/SetNewPassword/SetNewPassword";
import DoctorOverviewsPage from "../../Profile/pages/OverviewsPDoctor/DoctorOverviewsPage";
import WaitingRoom from "../../WaitingRoom/pages/WaitingRoom/WaitingRoom";
import CabinetDashboard from "../../cabinetDashboard/pages/CabinetDashboard/CabinetDashboard";
import SousProfile from "../../sous-profile/pages/sousProfile";
import EmancipationRedirect from "../../sous-profile/pages/EmancipationRedirect";
import LoginAdmin from "../../AdminDashboard/pages/LoginPage";
import AdminPage from "../../AdminDashboard/pages/AdminPage";
import ProtectedAdminRoute from "../adminRoutes/ProtectedAdminRoutes";
import AssistantsDirectory from "../../assistanAi/pages/AssistantsDirectory/AssistantsDirectory";
import LoginAssistant from "../../authAssistant/pages/LoginAssistant/LoginAssistant";
import VerifyAssistantCode from "../../authAssistant/pages/VerifyAssistantCode/VerifyAssistantCode";
import AssistantInvitationActivation from "../../authAssistant/pages/AssistantInvitationActivation/AssistantInvitationActivation";
import AssistantAvailabilityPage from "../../assistantDashboard/pages/Availability/AssistantAvailabilityPage";
import AssistantAppointmentsPage from "../../assistantDashboard/pages/Appointments/AssistantAppointmentsPage";
import AssistantWaitingRoomPage from "../../assistantDashboard/pages/WaitingRoom/AssistantWaitingRoomPage";
import AssistantPaymentHistoryPage from "../../assistantDashboard/pages/PaymentHistory/AssistantPaymentHistoryPage";
import AssistantPatientsPage from "../../assistantDashboard/pages/Patients/AssistantPatientsPage";
import AssistantPharmaciesPage from "../../assistantDashboard/pages/Places/AssistantPharmaciesPage";
import AssistantClinicsPage from "../../assistantDashboard/pages/Places/AssistantClinicsPage";
import AssistantAnalysisLabPage from "../../assistantDashboard/pages/Places/AssistantAnalysisLabPage";
import AssistantNursesPage from "../../assistantDashboard/pages/Places/AssistantNursesPage";
import PlansAssistant from "../../payment/pages/PlansAssistant/PlansAssistant";
import AssistantCabinetDashboard from "../../assistantDashboard/pages/CabinetDashboard/AssistantCabinetDashboard";
import Plans from "../../payment/pages/Plans/Plans";
import PlansDoctor from "../../payment/pages/PlansDoctor/PlansDoctor";
import PatientPaymentHistoryPage from "../../payment/pages/PatientPaymentHistory/PatientPaymentHistoryPage";
import PaymentSuccess from "../../payment/pages/PaymentSuccess/PaymentSuccess";
import PaymentFail from "../../payment/pages/PaymentFail/PaymentFail";
import PatientMedicalAccessPage from "../../authorization/PatientMedicalAccessPage";
import NeurologueConsultationPage from "../../specialty/neurologue/pages/NeurologueConsultationPage/NeurologueConsultationPage";
import PulmonologyConsultationPage from "../../specialty/pulmonology/pages/PulmonologyConsultationPage/PulmonologyConsultationPage";

// ─── ✅ Guard Doctor ───────────────────────────────────────────────────────────
const isDoctorAuthenticated = () =>
  !!(
    Cookies.get("doctorAccessToken") ||
    Cookies.get("doctorToken") ||
    Cookies.get("doctor_token") ||
    localStorage.getItem("doctorAccessToken") ||
    localStorage.getItem("doctorToken") ||
    localStorage.getItem("doctor_token")
  );

const isPatientAuthenticated = () =>
  !!(
    Cookies.get("accessToken") ||
    Cookies.get("auth_token") ||
    Cookies.get("token")
  );

function ProtectedDoctorRoute({ children }) {
  const location = useLocation();

  if (!isDoctorAuthenticated()) {
    /* ✅ Un patient connecté peut atterrir sur une route médecin (lien
       /drprofile/:id depuis le feed, notification, lien partagé…). Dans ce cas
       on ne touche NI à ses cookies NI à son rôle : sinon il se retrouve
       déconnecté avec une page vide. On le renvoie vers l'équivalent patient. */
    if (isPatientAuthenticated()) {
      const drProfileMatch = location.pathname.match(/^\/drprofile\/([^/?#]+)/i);
      if (drProfileMatch) {
        return (
          <Navigate to={DOCTOR_ROUTES.PROFILE_DOCTOR(drProfileMatch[1])} replace />
        );
      }
      return <Navigate to="/" replace />;
    }

    localStorage.removeItem("userRole");
    return <Navigate to="/LoginDoctor" state={{ from: location }} replace />;
  }

  return children ?? <Outlet />;
}

const isAssistantAuthenticated = () =>
  !!(
    Cookies.get("assistantAccessToken") ||
    Cookies.get("assistantToken") ||
    localStorage.getItem("assistantAccessToken") ||
    localStorage.getItem("assistantToken")
  );

function ProtectedAssistantRoute({ children }) {
  const location = useLocation();

  if (!isAssistantAuthenticated()) {
    localStorage.removeItem("userRole");
    return <Navigate to={ASSISTANT_ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return children ?? <Outlet />;
}
// ──────────────────────────────────────────────────────────────────────────────

const Placeholder = ({ title, subtitle }) => (
  <div
    style={{
      background: "#fff",
      borderRadius: 12,
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      padding: 40,
      margin: 20,
    }}
  >
    <h2 style={{ margin: 0, fontSize: 28, fontWeight: 600, color: "#333" }}>
      {title}
    </h2>
    {subtitle && <p style={{ marginTop: 10, color: "#666" }}>{subtitle}</p>}
  </div>
);

const getPatientId = () =>
  (
    Cookies.get("user_id") ||
    Cookies.get("userId") ||
    Cookies.get("id") ||
    ""
  ).trim();

const decodeJwtUserId = (token) => {
  if (!token) return "";
  const parts = token.split(".");
  if (parts.length < 2) return "";
  try {
    const payload = JSON.parse(atob(parts[1]));
    return (payload?.sub || payload?.id || payload?.userId || "").toString();
  } catch {
    return "";
  }
};

function RedirectToOwnProfile() {
  const [searchParams] = useSearchParams();

  const persistId = (id) => {
    if (!id) return;
    Cookies.set("userId", id);
    Cookies.set("id", id);
  };

  const paramId = (
    searchParams.get("userId") ||
    searchParams.get("id") ||
    ""
  ).trim();
  if (paramId) {
    persistId(paramId);
    return <Navigate to={ROUTES.FEED(paramId)} replace />;
  }

  const storedId = getPatientId();
  if (storedId) {
    persistId(storedId);
    return <Navigate to={ROUTES.FEED(storedId)} replace />;
  }

  const token = Cookies.get("accessToken");
  const decodedId = decodeJwtUserId(token);
  if (decodedId) {
    persistId(decodedId);
    return <Navigate to={ROUTES.FEED(decodedId)} replace />;
  }

  return <Navigate to={ROUTES.LOGIN} replace />;
}

export default function Navigation() {
  const location = useLocation();
  const path = (location?.pathname || "").toLowerCase();

  const isCyclePage = useMemo(() => {
    const p = (location?.pathname || "").toLowerCase();
    const CYCLE_PATHS = ["/cycle", "/patient/cycle", "/calendar/cycle"];
    return CYCLE_PATHS.some((x) => p === x || p.startsWith(x + "/"));
  }, [location?.pathname]);

  const doctorRoutePrefixes = [
    "/doctor",
    "/feeddoctor",
    "/appointmentsdoctor",
    "/patients",
    "/patientrecord",
    "/patientprofile",
    "/perscription",
    "/doctorprofile",
    "/settingsdoctor",
    "/register",
    "/logindoctor",
    "/verifcode",
    "/forgetpassword",
    "/emailcode",
    "/setnewpassworddoctor",
    "/availability",
    "/pharmacies",
    "/clinics",
    "/analysis-lab",
    "/nurses",
    "/messaging",
    "/medical-questions-doctor",
    "/doctorpages",
    "/cabinet-dashboard",
    "/drprofile",
    "/assistants",
  ];

  const assistantRoutePrefixes = [
    "/assistant",
    "/loginassistant",
    "/verifyassistantcode",
  ];

  const isDoctorArea = doctorRoutePrefixes.some((prefix) =>
    path.startsWith(prefix.toLowerCase())
  );

  const isAssistantArea = assistantRoutePrefixes.some((prefix) =>
    path.startsWith(prefix.toLowerCase())
  );

  useAuthSession({ auto: false, disabled: isDoctorArea || isAssistantArea });

  const isAuthRoute = useMemo(() => {
    const authKeywords = [
      "loginpatient",
      "signuppatient",
      "verifycode",
      "forgotpassword",
      "setnewpassword",
      "register",
      "logindoctor",
      "verifcode",
      "forgetpassword",
      "emailcode",
      "loginassistant",
      "verifyassistantcode",
      "assistant/invitation",
      "assistant/activate",
      "emancipation",
    ];
    const byKeyword = authKeywords.some((k) => path.includes(k));

    const patientAuthPaths = [
      ROUTES.LOGIN,
      ROUTES.SIGNUP_PATIENT,
      ROUTES.VERIFY_CODE,
      ROUTES.FORGOT_PASSWORD,
      ROUTES.SET_NEW_PASSWORD,
    ]
      .filter(Boolean)
      .map((p) => String(p).toLowerCase());

    const doctorAuthPaths = [
      DOCTOR_ROUTES.REGISTER_1,
      DOCTOR_ROUTES.REGISTER_2,
      DOCTOR_ROUTES.REGISTER_3,
      DOCTOR_ROUTES.REGISTER_4,
      DOCTOR_ROUTES.LOGIN,
      DOCTOR_ROUTES.VERIFY_CODE,
      DOCTOR_ROUTES.FORGOT_PASSWORD,
      DOCTOR_ROUTES.EMAIL_CODE,
    ]
      .filter(Boolean)
      .map((p) => String(p).toLowerCase());

    const allAuthPaths = [...patientAuthPaths, ...doctorAuthPaths];
    const assistantAuthPaths = [
      ASSISTANT_ROUTES.LOGIN,
      ASSISTANT_ROUTES.VERIFY_CODE,
      ASSISTANT_ROUTES.INVITATION_ACTIVATION,
    ]
      .filter(Boolean)
      .map((p) => String(p).toLowerCase());

    const allAuthPathsWithAssistant = [...allAuthPaths, ...assistantAuthPaths];

    const byExact =
      allAuthPathsWithAssistant.some((p) => path === p) ||
      allAuthPathsWithAssistant.some((p) => path.startsWith(p + "/"));

    return byKeyword || byExact;
  }, [path]);

  const isLandingPage = path === "/";
  const showAssistant = !isAuthRoute && !isDoctorArea && !isAssistantArea && !isLandingPage;

  return (
    <>
      <Routes>
        {/* ─── Landing ──────────────────────────────────────────────────── */}
        <Route path={ROUTES.LANDING} element={<PublicRouteAuth><LandingPage /></PublicRouteAuth>} />

        {/* ─── Patient Public ───────────────────────────────────────────── */}
        <Route path="/pets" element={<Pets />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/Medications" element={<Medications />} />
        <Route path="/auth/callback" element={<OAuthCallback />} />
        <Route path="/emancipation" element={<EmancipationRedirect />} />
        <Route path="/ResetPassword" element={<SetNewPassword />} />
        <Route path="/placeholder" element={<Placeholder title="Placeholder" />} />
        <Route path="/family-tree" element={<SousProfile />} />
        <Route path="/waiting-room" element={<WaitingRoom />} />
        <Route path={ROUTES.PAYMENT_SUCCESS} element={<PaymentSuccess />} />
        <Route path={ROUTES.PAYMENT_FAIL} element={<PaymentFail />} />

        {/* ─── Patient Auth ─────────────────────────────────────────────── */}
        <Route path={ROUTES.LOGIN} element={<PublicRouteAuth><LoginPatient /></PublicRouteAuth>} />
        <Route path={ROUTES.SIGNUP_PATIENT} element={<SignupPatient />} />
        <Route path={ROUTES.VERIFY_CODE} element={<VerifyCode />} />
        <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />

        {/* ─── Patient Main ─────────────────────────────────────────────── */}
        <Route path={ROUTES.MEDICAL_RECORD} element={<ProtectedRoute><PatientMedicalRecord /></ProtectedRoute>} />
        <Route path={ROUTES.OVERVIEWS} element={<OverViewsPage />} />
        <Route path={ROUTES.RECORDS_TYPE} element={<RecordType />} />
        <Route path={ROUTES.WASTEBASKET} element={<Wastebasket />} />
        <Route path="/medical-questionspage" element={<MedicalQuestionsPage />} />
        <Route path={ROUTES.CYCLE || "/cycle"} element={<Cycle />} />
        <Route path={ROUTES.MESSAGING} element={<Messaging />} />
        <Route path={ROUTES.APPOINTMENTS} element={<Appointments />} />
        <Route path={ROUTES.DOCTOR_DETAILS(":doctorId")} element={<DoctorDetails />} />
        <Route path={DOCTOR_ROUTES.PROFILE_DOCTOR(":doctorId")} element={<DoctorPatientProfile />} />
        <Route path={ROUTES.PHARMACY} element={<Pharmacy />} />
        <Route path={ROUTES.LAB} element={<Lab />} />
        <Route path={ROUTES.CLINIQUE} element={<Clinique />} />
        <Route path={ROUTES.KINE} element={<Kine />} />
        <Route path={ROUTES.INFIRMARIES} element={<Inf />} />
        <Route path={ROUTES.MEDICINES} element={<PatientMedicines />} />
        <Route path={ROUTES.SIDE_DEMO} element={<SideBar />} />
        <Route path={ROUTES.MedicalASSISTANT} element={<MedicalAssistant />} />
        <Route path={ROUTES.PAYMENT} element={<Plans />} />
        <Route path="/specialty/neurologue" element={<NeurologueConsultationPage />} />
        <Route path="/specialty/pulmonology" element={<PulmonologyConsultationPage />} />

        {/* ─── Profile ──────────────────────────────────────────────────── */}
        <Route path="/profile" element={<RedirectToOwnProfile />} />
        <Route path="/profile/access-requests" element={<PatientMedicalAccessPage />} />
        <Route path={ROUTES.PROFILE(":userId")} element={<Profile />} />
        <Route path={ROUTES.PROFILE_EDIT} element={<ProfileEdit />}>
          <Route index element={<Navigate to="general" replace />} />
          <Route path="general" element={<GeneralForm />} />
          <Route path="history" element={<HistoryForm />} />
          <Route path="insurance" element={<InsuranceForm />} />
          <Route path="*" element={<Navigate to="general" replace />} />
        </Route>

        {/* ─── Feed ─────────────────────────────────────────────────────── */}
        <Route path="/feed" element={<RedirectToOwnProfile />} />
        <Route path={ROUTES.FEED(":userId")} element={<Feed />} />

        {/* ─── Maps / Doctor Finder ─────────────────────────────────────── */}
        <Route element={<MapsLayout />}>
          <Route path={DOCTOR_FINDER_ROUTES.LIST} element={<DoctorFinder />} />
        </Route>

        {/* ─── Doctor Auth (publiques) ──────────────────────────────────── */}
        <Route path={DOCTOR_ROUTES.REGISTER_1} element={<RegisterForm1 />} />
        <Route path={DOCTOR_ROUTES.REGISTER_2} element={<RegisterForm2 />} />
        <Route path={DOCTOR_ROUTES.REGISTER_3} element={<RegisterForm3 />} />
        <Route path={DOCTOR_ROUTES.REGISTER_4} element={<RegisterForm4 />} />
        <Route path={DOCTOR_ROUTES.LOGIN} element={<PublicRouteAuth><LoginDoctor /></PublicRouteAuth>} />
        <Route path={DOCTOR_ROUTES.VERIFY_CODE} element={<VerifCode />} />
        <Route path={DOCTOR_ROUTES.FORGOT_PASSWORD} element={<ForgetPassword />} />
        <Route path={DOCTOR_ROUTES.EMAIL_CODE} element={<EmailCode />} />
        <Route path="/SetNewPasswordDoctor" element={<SetNewPasswordDoctor />} />

        {/* ─── Assistant Auth (publiques) ───────────────────────────────── */}
        <Route path={ASSISTANT_ROUTES.LOGIN} element={<LoginAssistant />} />
        <Route path={ASSISTANT_ROUTES.VERIFY_CODE} element={<VerifyAssistantCode />} />
        <Route
          path={ASSISTANT_ROUTES.INVITATION_ACTIVATION}
          element={<AssistantInvitationActivation />}
        />

        {/* ─── Doctor Main (protégées) ──────────────────────────────────── */}
        <Route
          path={DOCTOR_ROUTES.FEED}
          element={<ProtectedDoctorRoute><FeedDoctor /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.PROFILE}
          element={<ProtectedDoctorRoute><ProfilDoctor /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.SETTINGS}
          element={<ProtectedDoctorRoute><SettingsDoctor /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.APPOINTMENTS}
          element={<ProtectedDoctorRoute><AppointmentsDoctor /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.PATIENTS}
          element={<ProtectedDoctorRoute><Patients /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.PATIENT_RECORD(":id")}
          element={<ProtectedDoctorRoute><PatientRecord /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.PRESCRIPTION}
          element={<ProtectedDoctorRoute><Perscription /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.AVAILABILITY}
          element={<ProtectedDoctorRoute><AvailibilityPage title="availability" /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.PROFILE_DR(":doctorId")}
          element={<ProtectedDoctorRoute><DrProfile /></ProtectedDoctorRoute>}
        />
        <Route
          path="/doctor-medicines"
          element={<ProtectedDoctorRoute><MedicationsDoctor /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.PHARMACIES}
          element={<ProtectedDoctorRoute><Pharma /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.CLINICS}
          element={<ProtectedDoctorRoute><Clinic /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.LABS}
          element={<ProtectedDoctorRoute><Laboratory /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.NURSES}
          element={<ProtectedDoctorRoute><Nurses /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.MEDICAL_QUESTIONS}
          element={<ProtectedDoctorRoute><MedicalQuestionsDoctor /></ProtectedDoctorRoute>}
        />
        <Route
          path={MESSAGING_ROUTES.DOCTOR}
          element={<ProtectedDoctorRoute><MessagingDoctor /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.FILE}
          element={<ProtectedDoctorRoute><File /></ProtectedDoctorRoute>}
        />
        <Route
          path="/cabinet-dashboard"
          element={<ProtectedDoctorRoute><CabinetDashboard /></ProtectedDoctorRoute>}
        />
        <Route
          path="/subscription"
          element={<ProtectedDoctorRoute><PlansDoctor /></ProtectedDoctorRoute>}
        />
        <Route
          path={DOCTOR_ROUTES.ASSISTANTS}
          element={<ProtectedDoctorRoute><AssistantsDirectory /></ProtectedDoctorRoute>}
        />




<Route
  path="/case-discussions"
  element={<ProtectedDoctorRoute><MedicalCaseDiscussions /></ProtectedDoctorRoute>}
/>
<Route
  path="/case-discussions/create"
  element={<ProtectedDoctorRoute><CreateCase /></ProtectedDoctorRoute>}
/>
<Route
  path="/case-discussions/:id"
  element={<ProtectedDoctorRoute><MedicalCaseDetail /></ProtectedDoctorRoute>}
/>
<Route
  path="/case-discussions/:id/live"
  element={<ProtectedDoctorRoute><MedicalCaseLive /></ProtectedDoctorRoute>}
/>

        {/* ─── Assistant Main (protégées) ────────────────────────────────── */}
        <Route
          path={ASSISTANT_ROUTES.AVAILABILITY}
          element={
            <ProtectedAssistantRoute>
              <AssistantAvailabilityPage />
            </ProtectedAssistantRoute>
          }
        />
        <Route
          path={ASSISTANT_ROUTES.APPOINTMENTS}
          element={
            <ProtectedAssistantRoute>
              <AssistantAppointmentsPage />
            </ProtectedAssistantRoute>
          }
        />
        <Route
          path={ASSISTANT_ROUTES.PATIENTS}
          element={
            <ProtectedAssistantRoute>
              <AssistantPatientsPage />
            </ProtectedAssistantRoute>
          }
        />
        <Route
          path={ASSISTANT_ROUTES.WAITING_ROOM}
          element={
            <ProtectedAssistantRoute>
              <AssistantWaitingRoomPage />
            </ProtectedAssistantRoute>
          }
        />
        <Route
          path={ASSISTANT_ROUTES.PAYMENT_HISTORY()}
          element={
            <ProtectedAssistantRoute>
              <AssistantPaymentHistoryPage />
            </ProtectedAssistantRoute>
          }
        />
        <Route
          path={ASSISTANT_ROUTES.PHARMACIES}
          element={
            <ProtectedAssistantRoute>
              <AssistantPharmaciesPage />
            </ProtectedAssistantRoute>
          }
        />
        <Route
          path={ASSISTANT_ROUTES.CLINICS}
          element={
            <ProtectedAssistantRoute>
              <AssistantClinicsPage />
            </ProtectedAssistantRoute>
          }
        />
        <Route
          path={ASSISTANT_ROUTES.ANALYSIS_LAB}
          element={
            <ProtectedAssistantRoute>
              <AssistantAnalysisLabPage />
            </ProtectedAssistantRoute>
          }
        />
        <Route
          path={ASSISTANT_ROUTES.NURSES}
          element={
            <ProtectedAssistantRoute>
              <AssistantNursesPage />
            </ProtectedAssistantRoute>
          }
        />
        <Route
          path={ASSISTANT_ROUTES.PAYMENT}
          element={
            <ProtectedAssistantRoute>
              <PlansAssistant />
            </ProtectedAssistantRoute>
          }
        />
        <Route
          path={ASSISTANT_ROUTES.CABINET_DASHBOARD}
          element={
            <ProtectedAssistantRoute>
              <AssistantCabinetDashboard />
            </ProtectedAssistantRoute>
          }
        />

        {/* ─── Doctor patient viewer (nested + protégé) ─────────────────── */}
        <Route
          path={DOCTOR_ROUTES.DOCTOR_PATIENT_VIEW(":patientId")}
          element={
            <ProtectedDoctorRoute>
              <Outlet />
            </ProtectedDoctorRoute>
          }
        >
          <Route index element={<Navigate to={DOCTOR_ROUTES.OVERVIEWS_DECOR} replace />} />
          <Route path={DOCTOR_ROUTES.OVERVIEWS_DECOR} element={<DoctorOverviewsPage />} />
          <Route path={DOCTOR_ROUTES.MEDICAL_RECORD_DECOR} element={<DoctorMedicalRecordPage />} />
          <Route path={DOCTOR_ROUTES.MEDICINES_DECOR} element={<DoctorMedicinesPage />} />
          <Route path="payment-history" element={<PatientPaymentHistoryPage role="doctor" />} />
          <Route path="records/:type" element={<DoctorRecordType />} />
        </Route>

        {/* ─── Admin ────────────────────────────────────────────────────── */}
        <Route path={ADMIN_ROUTES.LOGIN} element={<LoginAdmin />} />
        <Route element={<ProtectedAdminRoute />}>
          <Route path={ADMIN_ROUTES.DASHBOARD} element={<AdminPage />} />
        </Route>

        {/* ─── Catch-all → login patient ────────────────────────────────── */}
        <Route path="*" element={<Navigate to={ROUTES.LOGIN} replace />} />
      </Routes>

      {showAssistant && !isCyclePage && <AssistantBubble />}
    </>
  );
}
